import React from 'react';

import {ProcedureType} from 'graphql-client/__generated/graphqlGlobalTypes';
import getProcedureUIString, {ProceduresStringKeys, StringCase} from 'procedures/ProceduresStringKeys';
import InlineBanner, {InlineBannerType} from 'ui-library/banners/InlineBanner';

export function NoMethodWarningBanner(props: {procedureType: ProcedureType}): JSX.Element {
  return (
    <InlineBanner
      bannerType={InlineBannerType.WARNING}
      text={`No ${getProcedureUIString(ProceduresStringKeys.METHOD, props.procedureType, {
        stringCase: StringCase.LOWER,
        plural: true,
      })} have been configured for this ${getProcedureUIString(
        ProceduresStringKeys.PROCEDURE,
        props.procedureType,
        {
          stringCase: StringCase.LOWER,
        }
      )}.`}
      supportingInfo={`To vary conditions, close the experiment plan and add ${getProcedureUIString(
        ProceduresStringKeys.METHOD,
        props.procedureType,
        {stringCase: StringCase.LOWER, prependAorAn: true}
      )} to the ${getProcedureUIString(ProceduresStringKeys.PROCEDURE, props.procedureType, {
        stringCase: StringCase.LOWER,
      })}.`}
    />
  );
}

export function NoProcedureWarningBanner(props: {procedureType: ProcedureType}): JSX.Element {
  return (
    <InlineBanner
      bannerType={InlineBannerType.WARNING}
      text={`${getProcedureUIString(ProceduresStringKeys.PROCEDURE, props.procedureType, {
        stringCase: StringCase.SENTENCE,
        prependAorAn: true,
      })} must be selected before configuring conditions.`}
    />
  );
}
